// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"a9038f0e","410":"67e7e7b6","540":"ba1047ae","787":"dc562616","874":"1313dd00","914":"4979da43","952":"53910ed6","993":"877db89d"}[chunkId] + ".chunk.js";
};